import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { StagePlanGetPointsByStageIdSubStage, StagePlanGetPointsByStageIdSubStageResponse, SubStages } from '../../api/dtos';


const getData = (response?: SWRResponse<StagePlanGetPointsByStageIdSubStageResponse, StagePlanGetPointsByStageIdSubStageResponse>) => {
    return response?.data?.plotPoints
};
const getError = (response?: SWRResponse<StagePlanGetPointsByStageIdSubStageResponse, StagePlanGetPointsByStageIdSubStageResponse>) => (response?.error ?? response?.data)?.responseStatus;

const useStagePlanPlotPointsByStageIdSubStage = (stageId?: number, subStage?: SubStages, configuration?: SWRConfiguration<StagePlanGetPointsByStageIdSubStageResponse, StagePlanGetPointsByStageIdSubStageResponse>) => {
    
    const request = useMemo(() => {
        return stageId ?
            () => {
                return new StagePlanGetPointsByStageIdSubStage({ stageId: stageId, subStage: subStage });
            } :
            undefined;
    }, [stageId, subStage])

    return useGet(request, { getData, getError }, configuration);
}

export default useStagePlanPlotPointsByStageIdSubStage;